module.exports = __webpack_public_path__ + "img/entp-selected.72e238ca.png";